import { type ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import Seo, { type SeoProps } from "@/seo/Seo";
import { Analytics } from "@/seo/Analytics";
import { BreakingNewsTicker } from "@/components/shared/BreakingNewsTicker";
import { SupportChatWidget } from "@/components/shared/SupportChatWidget";
import { useLocation } from "wouter";
import { PUBLIC_PAGE_SEO } from "@shared/publicPageSeo";

interface LayoutProps {
  children: ReactNode;
  seo?: SeoProps;
}

export function Layout({ children, seo }: LayoutProps) {
  const [location] = useLocation();
  const defaults = PUBLIC_PAGE_SEO[location.split("?")[0]];
  return (
    <div className="min-h-screen flex flex-col bg-[#0a101f] text-white font-sans">
      <Seo {...defaults} {...seo} />
      <Analytics />
      <div className="sticky top-[var(--market-ticker-h,0px)] z-[100]">
        <Navbar />
        <BreakingNewsTicker />
      </div>
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <SupportChatWidget />
    </div>
  );
}
